import { useQuery } from '@tanstack/react-query'
import { listaDeConversaciones, type ConversacionDelBrain } from '@/services/brainApi'
import { queryKeys } from '../keys'

// A run in one of these is the Brain still thinking. Waiting for a person is
// not: nothing moves until someone answers, so there is nothing to watch.
const THINKING = new Set(['queued', 'working'])

export function isThinking(conversation: ConversacionDelBrain): boolean {
  return Boolean(conversation.active_run && THINKING.has(conversation.active_run.status))
}

/**
 * The saved Brain conversations, newest first.
 *
 * While any of them is thinking the list asks again every few seconds, so its
 * «thinking» mark goes away when the run ends -- also for a conversation that
 * is not the one open, which nothing else would tell the screen about.
 */
export function useBrainConversationsQuery() {
  return useQuery({
    queryKey: queryKeys.brain.conversations(),
    queryFn: listaDeConversaciones,
    refetchInterval: (query) => (query.state.data?.some(isThinking) ? 3000 : false),
  })
}
